<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rowsNotification }}</p>
                </b-col>
                <b-col lg="9">
                    <div style="display: flex">
                        <div style="flex: 1"></div>
                        <div>
                            <b-pagination v-model="currentPage" :total-rows="rowsNotification" :per-page="perPage" align="right" size="sm"></b-pagination>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div style="height: 100%" class="sa-test">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="listaNotificationNotipayResponse" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            <span> {{ (currentPage - 1) * perPage + row.index + 1 }} </span>
                        </template>
                        <template v-slot:cell(createDate)="{ item }">
                            <span> {{ formatDateTime(item.createDate) }} </span>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button v-if="row.item.esito === 'ERROR'" size="sm" class="mr-1 ml-1 no-text" variant="outline-success" @click="onClickResend(row.item)">
                                    <b-icon icon="arrow90deg-right"></b-icon>
                                </b-button>
                                <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary" @click="onVisualizza(row.item)">
                                    <font-awesome-icon icon="eye" />
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <div class="sa-list-component-invisible">
            <notification-notipay-modal-edit-component ref="mdlNotificationNotipayEditComponent" @afterSave="onAfterSave" />
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rowsNotification }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rowsNotification" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
// import PrintComponent from "../../../utility/components/PrintComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import NotificationNotipayMixin from "../mixin/NotificationNotipayMixin";
import NotificationNotipayModalEditComponent from "./NotificationNotipayModalEditComponent.vue";

export default {
    name: "NotificationNotipayListComponent",
    props: {},
    mixins: [UtilityMixin, NotificationNotipayMixin],
    components: { NotificationNotipayModalEditComponent },
    data() {
        return {
            view: "list",
            rowsNotification: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/notificationnotipay",
            filtroGestioneOspiti: {},
            stampaReport: "",
            items: [],
            listKey: 0,
            isButtonVisible: true,
            fields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 0.5rem",
                },
                {
                    label: "Esito",
                    key: "esito",
                },
                {
                    label: "Utente",
                    key: "proprietario",
                },
                {
                    label: "Data e Ora",
                    key: "createDate",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE" },
            ],
        };
    },
    computed: {},
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            this.loadDataListaNotificationNotipayResponse(null);
        },
        onEdit() {},
        onVisualizza(item) {
            let me = this;
            me.$router.push("/notificationnotipay/view/" + item.id);
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
            me.loadData();
        },
        onBeforeLoadData() {
            let me = this;
            me.$emit("beforeLoadData");
        },
        nuovaNotifica() {
            let me = this;
            me.$refs.mdlNotificationNotipayEditComponent.show();
        },
        onAfterSave() {
            this.loadData();
        },
        onClickResend(item) {
            let me = this;
            let jsonData = JSON.parse(item.bodyRequest);
            me.saveResource(me.pathResource, jsonData, me.resultResponseSave);
        },
        resultResponseSave() {
            this.loadData();
        },
    },
};
</script>
